"use client"

import { useEffect } from "react"
import posthog from "posthog-js"

import { Button } from "@/components/ui/button"

export default function EmbedErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    posthog.capture("react_error_boundary_triggered", {
      boundary: "embed",
      error_name: error.name || "Error",
      error_message: error.message?.slice(0, 300),
      error_stack: error.stack?.slice(0, 1000),
      digest: error.digest,
    })
  }, [error])

  return (
    <div className="flex min-h-[320px] flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-lg font-semibold">Jobs could not be loaded</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        This job board is temporarily unavailable. Please try again.
      </p>
      <Button type="button" onClick={reset} className="min-h-11">
        Try again
      </Button>
    </div>
  )
}
